// export const buildVersion = "uat | 1.0.0";
export const buildVersion = "prod | 1.0.0";
